itsoftApp.createModule("customMap", function () {
    let mapPins = document.querySelectorAll(".contacts__pin");
    let mapCards = document.querySelectorAll(".contacts__item");

    Array.prototype.forEach.call(mapPins, function (pin, pinId) {
        pin.addEventListener("mouseover", function () {
            mapCards[pinId].classList.add("is-hover");
        });

        pin.addEventListener("mouseout", function () {
            mapCards[pinId].classList.remove("is-hover");
        });
    });

    Array.prototype.forEach.call(mapCards, function (card, cardId) {
        card.addEventListener("mouseover", function () {
            mapPins[cardId].classList.add("is-hover");
        });

        card.addEventListener("mouseout", function () {
            mapPins[cardId].classList.remove("is-hover");
        });
    });
});